const TroubleshootPage = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-white">Troubleshoot</h1>
      <p className="text-gray-400 mt-2">Troubleshooting tools content</p>
    </div>
  );
};
export default TroubleshootPage;